import modules from './modules'
import getters from './getters'

export default {
  modules,
  getters
}
